export function SettingsExtras() {
  return (
    <p className="mesh-settings-help">
      Edit skills and clear ratings from the main screen — they're shared with the whole room.
    </p>
  );
}
